import { Session } from '@shared/utils/Session/Session';
export class SessionsCache {
    constructor() {
        this._sessions = new Map();
    }
    getSession(id) {
        var _a;
        return (_a = this._sessions.get(id)) !== null && _a !== void 0 ? _a : null;
    }
    newMessage(msg) {
        let session = this.getSession(msg.id);
        if (session == null) {
            session = new Session(msg.id, msg.name);
            this._sessions.set(session.Id, session);
        }
        session.newMessage(msg);
        return session;
    }
    clear() {
        this._sessions.clear();
    }
}
